/**
 * Searchanise product grids: apply object-fit contain on supply products
 * when the image aspect ratio does not match the thumbnail frame.
 * Glass products (snize-product-tag-glass) always keep cover via CSS.
 */
(function () {
  const ASPECT_MISMATCH_THRESHOLD = 0.22
  const GLASS_TAG_CLASS = 'snize-product-tag-glass'
  const CONTAIN_CLASS = 'snize-thumb-fit-contain'
  const WIRE_INTERVAL_MS = 750
  const WIRE_DURATION_MS = 120000

  function isLikelySnizePage() {
    return (
      document.body.classList.contains('snize-results-page') ||
      !!document.querySelector('.searchanise-collections-browse') ||
      !!document.getElementById('snize_results') ||
      window.location.pathname.indexOf('search-results-page') !== -1
    )
  }

  function aspectMismatch(imageRatio, frameRatio) {
    if (!imageRatio || !frameRatio || !Number.isFinite(imageRatio) || !Number.isFinite(frameRatio)) {
      return false
    }
    return Math.abs(Math.log(imageRatio / frameRatio)) > ASPECT_MISMATCH_THRESHOLD
  }

  function evaluateProduct(product) {
    if (!product || product.classList.contains(GLASS_TAG_CLASS)) return

    const wrapper = product.querySelector('.snize-thumbnail-wrapper')
    const img = product.querySelector('.snize-thumbnail img')
    if (!wrapper || !img) return

    const applyFit = () => {
      const nw = img.naturalWidth
      const nh = img.naturalHeight
      if (!nw || !nh) return

      const frameW = wrapper.clientWidth
      const frameH = wrapper.clientHeight
      if (!frameW || !frameH) return

      const imageRatio = nw / nh
      const frameRatio = frameW / frameH
      const needsContain = aspectMismatch(imageRatio, frameRatio)

      product.classList.toggle(CONTAIN_CLASS, needsContain)
    }

    if (img.complete && img.naturalWidth > 0) {
      applyFit()
      return
    }

    img.addEventListener('load', applyFit, { once: true })
  }

  function wireAll() {
    const target = document.getElementById('snize_results')
    if (!target) return

    target.dataset.snizeThumbFitInit = 'true'
    target.querySelectorAll('.snize-product').forEach((product) => {
      evaluateProduct(product)
    })
  }

  function start() {
    if (!isLikelySnizePage()) return

    wireAll()

    const rootObs = new MutationObserver(() => {
      wireAll()
    })
    rootObs.observe(document.documentElement, { childList: true, subtree: true })

    const wireTimer = setInterval(wireAll, WIRE_INTERVAL_MS)

    window.addEventListener('resize', wireAll)
    window.addEventListener('load', wireAll, { once: true })

    document.addEventListener(
      'load',
      (event) => {
        if (event.target && event.target.matches && event.target.matches('.snize-thumbnail img')) {
          wireAll()
        }
      },
      true
    )

    setTimeout(() => {
      clearInterval(wireTimer)
      rootObs.disconnect()
    }, WIRE_DURATION_MS)
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true })
  } else {
    start()
  }
})()
